module.exports = __webpack_public_path__ + "static/img/gaozhonglishi12.e8bc1a76.jpg";